import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SafeUrl } from '@angular/platform-browser';
import { ApiService } from '../../services/api.service';
import { Subject, } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DomSanitizer } from '@angular/platform-browser';
import apiUrlPoint from '../../life-config/apiEndPoints.json';
import { MatSnackBar } from '@angular/material/snack-bar';
import {SharedApiService} from '../../services/shared-api.service';
@Component({
    selector: 'app-bi-pdf-url',
    templateUrl: './bi-pdf-url.component.html',
    styleUrls: ['./bi-pdf-url.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class BiPdfUrlComponent implements OnInit {

    // Class variable access
    proposalId: any;
    uuid: any;
    biPdfUrl?: SafeUrl;
    downloadBIPdfUrl: any;
    webBiPdfUrl: any;
    apiUrl: object = apiUrlPoint.apiEndPoints;
    destroySubject$: Subject<void> = new Subject();
    isMobileView = false;

    constructor(

        private apiService: ApiService,
        private activatedRoute: ActivatedRoute,
        private sanitizationService: DomSanitizer,
        private snackBar: MatSnackBar,
        private sharedData: SharedApiService,
    ) {

        this.sharedData.invokeBIEvent.subscribe(value => {
            if (value) {

                // this.biPdfUrl = value;
                const spiturl = value['changingThisBreaksApplicationSecurity'].split('.pdf');
                const atFirstIndex = spiturl[0];
                this.biPdfUrl = atFirstIndex;
                this.webBiPdfUrl = this.sanitizationService.bypassSecurityTrustResourceUrl(value['changingThisBreaksApplicationSecurity']);
                this.downloadBIPdfUrl = atFirstIndex;
            }
        });

     }


    ngOnInit() {

        this.activatedRoute.params.subscribe(params => {

            this.proposalId = params['proposalId'];
            this.uuid = params['uuid'];

        });

        if (this.proposalId && this.uuid) {
            this.customizeEvent();
            /**
             * Invoking method from services as it will be used for multiple places
             */

            this.sharedData.getBenefitIllustration(this.proposalId, this.uuid).subscribe(res => {
                if (res) {
                    this.getSafeUrl(  res['changingThisBreaksApplicationSecurity']);
                    const spiturl = res['changingThisBreaksApplicationSecurity'].split('.pdf');
                    const atFirstIndex = spiturl[0];
                    this.biPdfUrl = atFirstIndex;
                    this.downloadBIPdfUrl = atFirstIndex;
                    this.webBiPdfUrl = this.sanitizationService.bypassSecurityTrustResourceUrl(
                        res['changingThisBreaksApplicationSecurity']);
                    

                }

            });

        }

        

    }

    getSafeUrl(url) {
        if(url) {

            return this.sanitizationService.bypassSecurityTrustUrl(url);
        }
    }


    customizeEvent(){
        if(window.screen.width < 768){
            this.isMobileView = true;
        }
    }




    /**
     * Share BI -Email
     */

    shareBIOnEmail() {

        this.apiService.postWithoutData(
            this.apiUrl['apiV2LifeProposal'],
            this.proposalId,
             this.uuid,
             this.apiUrl['shareBIOnEmail'])
        .subscribe(res => {

            if (res) {

                this.openResponeMsg();


            }
        });

    }

    /**
     * Display message on sucessful response
     */

    openResponeMsg() {

        this.snackBar.open('BI shared to email ');

    }


}














